import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseWalletReport() {
  const MyAxios = UseCustomAxios();

  const GetWalletReport = (mobile, add, state, newMyPc, bool, callback) => {
    MyAxios.get(
      `Admin_UserWalletReport?add=${add}&state=${state}&w=${mobile}`,
      {
        headers: {
          Conditions: JSON.stringify({ pageCondition: newMyPc }),
          IsPage: bool,
        },
      }
    ).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  return {
    GetWalletReport,
  };
}
